<style lang="scss"></style>

<template>
  <div class="add-app-modal">
    <validation-observer ref="observer" v-slot="{ handleSubmit }">
      <b-form @submit.stop.prevent="handleSubmit(updateLocation)">

        <section class="mb-2">
          <div>
            <label>Location</label>
            <validation-provider
              v-slot="validationContext"
              name="Location"
              :rules="{ required: true, min: 1 }"
            >
              <b-form-input
                v-model="location" cy="location-update-input"
                :state="getValidationState(validationContext)" class="mb-1" placeholder="Enter location"
              />

              <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
            </validation-provider>
          </div>
        </section>

        <section class="d-inline-flex full-width mt-2">
          <div class="ui-spacer" />
          <b-button class="mr-2" @click="$emit('close', true)">Cancel</b-button>
          <b-button type="submit" variant="primary">Update Location</b-button>
        </section>
      </b-form>
    </validation-observer>
  </div>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import LocationService from '@/services/LocationService';

export default {
  components: {},
  props: {
    existingLocation: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      location: '',
    };
  },
  mounted() {
    this.location = this.existingLocation.location;
  },
  methods: {
    updateLocation() {
      LocationService.updateLocation(this.existingLocation._id, this.location).then(() => {
        this.$toast.success(`Updated location ${this.location} Successfully`, {
          toastClassName: ['toast-std', 'success-toast'],
        });

        this.$emit('refresh', true);
      }).catch(err => {
        let errorMsg = 'Could not update location, please refresh and try again';

        if (err.response && err.response.data && err.response.data.error === 'ENTITY_ALREADY_EXISTS') {
          errorMsg = 'Could not update location as one already exists with this name';
        }

        this.$toast.error(errorMsg, {
          toastClassName: ['toast-std', 'warning-toast'],
        });
      });
    },
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
  },
};
</script>
